import {differenceInCalendarDays} from 'date-fns';
import {toJstDate} from '../../../shared/services/dateUtils';

/*
- hours: 残り24時間未満（分・時間表示）
- days: 残り1〜7日
- none: 残り8日以上、または締切超過・不正な日付
*/
export type DeadlineCountdownType = 'hours' | 'days' | 'none';

type DeadlineCountdown = {
  type: DeadlineCountdownType;
  value: number;
  unit: '分' | '時間' | '日' | '';
};

const MINUTE_MS = 60 * 1000;
const HOUR_MS = 60 * MINUTE_MS;
const DAY_MS = 24 * HOUR_MS;

// 残り日数を表示する最大日数
const MAX_COUNTDOWN_DAYS = 7;

const NO_COUNTDOWN: DeadlineCountdown = {type: 'none', value: 0, unit: ''};

/** 締切までの残り時間を表示用の数値と単位に変換する */
export const getDeadlineCountdown = (deadline: Date): DeadlineCountdown => {
  if (Number.isNaN(deadline.getTime())) {
    return NO_COUNTDOWN;
  }

  const remainingMs = deadline.getTime() - Date.now();
  if (remainingMs <= 0) {
    return NO_COUNTDOWN;
  }

  if (remainingMs < HOUR_MS) {
    // 1分未満でも「あと1分」に丸める
    return {
      type: 'hours',
      value: Math.max(1, Math.floor(remainingMs / MINUTE_MS)),
      unit: '分',
    };
  }

  if (remainingMs < DAY_MS) {
    return {
      type: 'hours',
      value: Math.floor(remainingMs / HOUR_MS),
      unit: '時間',
    };
  }

  const diffDays = differenceInCalendarDays(
    toJstDate(deadline),
    toJstDate(new Date()),
  );
  if (diffDays < 1 || diffDays > MAX_COUNTDOWN_DAYS) {
    return NO_COUNTDOWN;
  }

  return {type: 'days', value: diffDays, unit: '日'};
};

/** 締切日時の文字列から残り時間の種別だけを求める（計測用） */
export const getDeadlineCountdownType = (
  entryEnd?: string,
): DeadlineCountdownType =>
  entryEnd ? getDeadlineCountdown(new Date(entryEnd)).type : 'none';
